import { createValidIcon } from '@ui/icons/utils/type-helper'

export const PhoneIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M7.64551 2C8.87216 2 9.97503 2.74686 10.4307 3.88574L11.4863 6.52148L11.5557 6.71484C11.8703 7.68971 11.6657 8.76356 11.0049 9.55664L10.4365 10.2363L10.4375 10.2373C10.1071 10.6338 10.1328 11.2176 10.499 11.584L12.416 13.502C12.7814 13.8673 13.3651 13.8935 13.7627 13.5625L14.4434 12.9951L14.6064 12.8691C15.4358 12.269 16.5196 12.1311 17.4785 12.5146L20.1143 13.5684C21.253 14.024 21.9998 15.1271 22 16.3535V19.1055C21.9998 20.7039 20.7043 22 19.1055 22C9.65849 22 2 14.3415 2 4.89453C2 3.29574 3.29605 2.00011 4.89453 2H7.64551ZM4.89453 4C4.40033 4.00011 4 4.40059 4 4.89453C4 13.2369 10.7631 20 19.1055 20C19.5993 20 19.9998 19.5997 20 19.1055V16.3535C19.9998 15.9958 19.8097 15.6698 19.5078 15.4922L19.3721 15.4258L16.7354 14.3711C16.437 14.2518 16.1027 14.2841 15.835 14.4512L15.7246 14.5312L15.0439 15.0986C13.9266 16.0298 12.3151 16.0189 11.2139 15.1094L11.001 14.916L9.08496 12.998C7.98863 11.9016 7.90648 10.1487 8.90039 8.95605L9.46875 8.27539C9.67463 8.02786 9.74719 7.69954 9.6709 7.39355L9.62891 7.26465L8.57422 4.62891C8.42236 4.24925 8.05441 4 7.64551 4H4.89453Z'
        fill={color}
      />
    </svg>
  )
})
